import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	userRoles: [],
	accessToken: "",
	userData: {},
	isUserLoggedIn: "not",
};

const userInfoSlice = createSlice({
	name: "userInfo",
	initialState,
	reducers: {
		setUserInfo(state, action) {
			state.userData = action.payload;
		},
		setUserRoles(state, action) {
			state.userRoles = action.payload.roles;
		},
		setAccessToken(state, action) {
			state.accessToken = action.payload;
		},
		setUserLoggedIn(state, action) {
			state.isUserLoggedIn = action.payload;
		},
	},
});

export const { setUserInfo, setUserRoles, setAccessToken, setUserLoggedIn } =
	userInfoSlice.actions;
export default userInfoSlice.reducer;
